import { addedToBasketNotification } from './added-to-basket-notification';
import { checkout } from './checkout';
import { createHorizontalScrollablePanelWithBestPerformingArticles } from './horizontal-scrollable-panel-best-performing-articles';
import { horizontalScrollablePanelBoughtThisSeason } from './horizontal-scrollable-panel-bought-this-season';
import { horizontalScrollablePanelBoughtThisSeasonLandingPage } from './horizontal-scrollable-panel-bought-this-season-landing-page';
import { horizontalScrollablePanelReStock } from './horizontal-scrollable-panel-re-stock';
import { squarePanelFromRecommendationsBestPerformingArticles } from './square-panel-best-performing-articles';
import { squarePanelFromRecommendationsProductsOnTheWay } from './square-panel-products-on-the-way';

export const bestseller = {
  addedToBasketNotification,
  checkout,
  horizontalScrollablePanekBestPerformingArticles:
    createHorizontalScrollablePanelWithBestPerformingArticles().root,
  horizontalScrollablePanelBoughtThisSeason,
  squarePanelFromRecommendationsBestPerformingArticles,
  horizontalScrollablePanelBoughtThisSeasonLandingPage,
  squarePanelFromRecommendationsProductsOnTheWay,
  horizontalScrollablePanelReStock,
};
